var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pdfView"},[_c('iframe',{attrs:{"src":_vm.pdfUrl,"frameborder":"0","width":"100%","height":"500px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }